import type { AtomKind } from "../model/atom.js";
import type { CellEffect } from "../model/cell.js";

const LEGAL_EFFECTS: Readonly<Record<CellEffect, Readonly<Record<AtomKind, readonly AtomKind[]>>>> =
  {
    merges: {
      constraint: ["constraint"],
      finding: ["finding"],
      goal: ["goal"],
      path: ["path"],
      problem: ["problem"],
      proof: ["proof"],
      tool: ["tool"],
    },
    proves: {
      constraint: [],
      finding: [],
      goal: [],
      path: [],
      problem: [],
      proof: ["constraint", "finding", "goal", "path", "tool"],
      tool: [],
    },
    supports: {
      constraint: [],
      finding: [],
      goal: [],
      path: ["goal"],
      problem: [],
      proof: ["goal", "path"],
      tool: ["path"],
    },
    targets: {
      constraint: [],
      finding: [],
      goal: [],
      path: [],
      problem: ["goal"],
      proof: [],
      tool: [],
    },
    threatens: {
      constraint: [],
      finding: ["goal", "path"],
      goal: [],
      path: [],
      problem: [],
      proof: [],
      tool: [],
    },
    uses: {
      constraint: [],
      finding: [],
      goal: [],
      path: ["proof", "tool"],
      problem: [],
      proof: [],
      tool: [],
    },
  };

export function isLegalCell(
  fromKind: AtomKind,
  effect: CellEffect,
  toKind: AtomKind,
) {
  return LEGAL_EFFECTS[effect][fromKind].includes(toKind);
}
